import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = (n) => (_pushScopeId("data-v-649bc702"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "bottomSheetOverlay" };
const _hoisted_2 = { class: "bottomSheet" };
const _hoisted_3 = { class: "btn-group" };
import DButton from "../button/SubmitButton.vue";
import { ref } from "vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'BottomSheet',
    props: {
        value: {
            type: String,
            default: "Are you sure you want to start the session?",
        },
    },
    emits: ["close", "start"],
    setup(__props, { emit: __emit }) {
        const props = __props;
        // Define the emit event
        const emit = __emit;
        const isClicked = ref(false);
        // Emit an event when the "No" button is clicked
        function handleClose() {
            emit("close");
        }
        // Emit an event when the "Yes" button is clicked
        function handleStart() {
            isClicked.value = true; // Disable the button
            // Simulate an action (e.g., API call)
            setTimeout(() => {
                isClicked.value = false; // Re-enable the button if needed
            }, 60000); // Re-enable after 3 seconds
            emit("start");
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("p", null, _toDisplayString(props.value), 1),
                    _createElementVNode("div", _hoisted_3, [
                        _createVNode(DButton, {
                            value: "No",
                            secondary: "",
                            onClick: handleClose,
                            disabled: isClicked.value
                        }, null, 8, ["disabled"]),
                        _createVNode(DButton, {
                            value: "Yes",
                            primary: "",
                            onClick: handleStart,
                            disabled: isClicked.value
                        }, null, 8, ["disabled"])
                    ])
                ])
            ]));
        };
    }
});
